import { redirect } from "next/navigation";
import parse from 'html-react-parser';
import DOMPurify from "isomorphic-dompurify";

export const DestructureAEMLayout = (data: any, redirectUrl = "/not-found") => {
  if (!data) {
    redirect(redirectUrl);
  }
  let Brochure = null;
  const containerItems = data?.[":items"]?.["root"]?.[":items"]?.["container"]?.[":items"]?.["container"]?.[":items"];

  if (containerItems) {
    const bannerKey = Object.keys(containerItems).find((key) =>
      key.startsWith("banner_")
    );

    if (bannerKey) {
      Brochure = containerItems[bannerKey];
    }
  }
  return {
    Items:
      data?.[":items"]?.["root"]?.[":items"]?.["container"]?.[":items"]?.[
        "container"
      ]?.[":items"] ?? {},
    ItemsOrder:
      data?.[":items"]?.["root"]?.[":items"]?.["container"]?.[":items"]?.[
        "container"
      ]?.[":itemsOrder"] ?? [],
    ItemsHeader:
      data?.[":items"]?.["root"]?.[":items"]?.["experiencefragment-header"]?.[
        ":items"
      ]?.["root"]?.[":items"]?.["header"] ?? [],
      Brochure
  };
};

export const createSlug = (text: string) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
};
export const matchedProducts = (
  productData: any[],
  mergedArray: string[],
  storeID: any
) => {
  const updatedArray: string[] = mergedArray.map(
    (item) => `${item}_${storeID}`
  );
  const filteredProducts = productData.filter((product) =>
    updatedArray.includes(product.objectID)
  );
  return filteredProducts;
};

export function convertColor(input: string): string {
  const rgbRegex =
    /^rgba?\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*(\d*(?:\.\d+)?))?\s*\)$/i;
  const isHex = /^#([0-9A-Fa-f]{6})$/.test(input.trim());
  if (isHex) {
    return input.toUpperCase();
  }

  const match = input.match(rgbRegex);
  if (match) {
    const r = parseInt(match[1], 10);
    const g = parseInt(match[2], 10);
    const b = parseInt(match[3], 10);

    const toHex = (value: number) => {
      const hex = value.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
  }

  // Fallback if input doesn't match
  return input.toUpperCase();
}

export const minutesToISO = (minutes: number): string => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  let iso = "PT";
  if (h > 0) iso += `${h}H`;
  if (m > 0 || iso === "PT") iso += `${m}M`;

  return iso;
};

export const timeConvertForRecipeSchema = (min: number): string => {
  const hours = Math.floor(min / 60);
  const minutes = min % 60;
  if (hours > 0 && minutes === 0) {
    return `${hours} h`;
  } else if (hours > 0) {
    return `${hours} h ${minutes} mins`;
  } else if (minutes > 1) {
    return `${minutes} mins`;
  } else {
    return `${minutes} min`;
  }
};

export function decodeHTMLEntities(str: any) {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
}



export function parseHtml(html: string): string {
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .replace(/amp;/g, "")
    .replace(/&nbsp;/g, "")
    .trim();
}

export function RenderHTML(text: string = "") {
  const clean = DOMPurify.sanitize(text, {
    ADD_ATTR: ['target']
  });
  return (parse(clean));
}
export function capitalizeFirst(text : any) {
  if (!text) return "";
  const path = text.split("/");
  return path[1].charAt(0).toUpperCase() + path[1].slice(1);
}
